const colors = {
  primary: '#c78c2f',
  lightGrey: '#ededed',
  darkGrey: '#d8d8d8',
  black: '#303030',
  red: '#d61600',
  greenBlue: '#2ad587',
  white: '#ffffff',
  overlay: 'rgba(56, 56, 56, 0.78)',
  whiteOverlay: 'rgba(255, 255, 255, 0.25)'
}

export default colors



// WEBPACK FOOTER //
// ./src/Themes/Colors.js